import { Length } from 'class-validator';

export class LoginByUidTokenModel {
  @Length(32, 64)
  public uid: string;

  @Length(32, 64)
  public token: string;

  constructor(uid: string, token: string) {
    this.uid = uid;
    this.token = token;
  }
}
